import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  ViewChild
} from '@angular/core';
import * as Chart from 'chart.js';

@Component({
  selector: 'app-chart-table',
  templateUrl: './chart-table.component.html',
  styleUrls: ['./chart-table.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChartTableComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() data;
  @Input() title;
  @Input() subtitle;
  @Input() chartModes = [];
  @Input() multiTable = false;
  @Input() tableButtonNames = [];
  @Input() defaultMode: 'line' | 'bar' | 'pie' = 'line';
  @Input() showTable = true;
  @Input() showChart = true;

  selectedTableIndex = 0;

  get lineMode() {
    return this.chartModes.includes('line');
  }
  get barMode() {
    return this.chartModes.includes('bar');
  }
  get pieMode() {
    return this.chartModes.includes('pie');
  }

  @ViewChild('canvas')
  canvas;

  chart;
  done = false;
  mode: 'line' | 'bar' | 'pie' = this.defaultMode;
  constructor() {}
  ngOnInit() {}
  ngAfterViewInit() {
    this.done = true;
    this.draw();
  }

  draw() {
    if (this.showChart) {
      const ctx = this.canvas.nativeElement.getContext('2d');
      const options = {
        maintainAspectRatio: false,
        responsive: true,
        display: true
      };
      if (this.chart) {
        this.chart.destroy();
      }
      if (this.mode === 'line') {
        this.chart = new Chart(ctx, {
          type: 'line',
          data: this.data && this.data.lineChart,
          options
        });
      } else if (this.mode === 'bar') {
        this.chart = new Chart(ctx, {
          type: 'bar',
          data: this.data && this.data.barChart,
          options
        });
      } else if (this.mode === 'pie') {
        this.chart = new Chart(ctx, {
          type: 'pie',
          data: this.data && this.data.pieChart,
          options
        });
      }
    }
  }

  setMode(mode) {
    if (this.mode !== mode) {
      this.mode = mode;
      this.draw();
    }
  }
  ngOnChanges(change) {
    if (this.done) {
      this.draw();
    }
  }

  setTableIndex(i) {
    this.selectedTableIndex = i;
  }
}
